import Vue from 'vue'
import getAvaiSpecs from './spec'
import skuEventBus from '../sku-select/eventBus'

let vm = null
function init({ spuInfo, skuInfo, skuId }) {
  // 离屏渲染模板复用重置
  vm = null
  skuEventBus.$off('selectSpecItem')
  let { specMain, specMainSeq, skuSpecList, specItemSeq } = spuInfo.specItem
  if (!vm) {
    vm = new Vue({
      data() {
        return {
          // 商品即使有活动，但在某些情况下依然要走常规购买流程，而不是活动购买流程，因此在这种单独购买流程下要在外部将actIgnore设置为true
          actIgnore: false,
          spuInfo,
          skuInfo,
          skuId,
          oldSkuId: '',
          specMain,
          specMainSeq,
          skuSpecList,
          specItemSeq,
          // 记录已选中的规格项， 形如{0: {id: 1, name: '全网通64g'}}的形式
          checkedSpecItem: {},
          // 选中的sku的规格项名称组合，如果当前选中的规格项不能组成sku，则为上一个sku的规格项组合
          skuSpecName: ''
        }
      },
      computed: {
        // 根据传入的规格数据进行数据转换，以sku的规格值id为key，形如{ 'specItemId1-specItemId2': skuId }
        skuMap() {
          const map = {}

          this.skuSpecList.forEach(sku => {
            const specItemIds = this.specMain.map(specId => sku.sequences[specId]).join('-')
            map[specItemIds] = sku.skuId
          })

          return map
        },
        // 缺货，下架的skuList
        noStoreSku() {
          // 拼购商品不会有下架和无库存sku，接口会过滤
          if (this.skuInfo?.commoditySkuDiscount?.commodityDiscountType == 'group' && !this.actIgnore) {
            return []
          }
          return this.spuInfo.zeroStoreSkuIds.concat(this.spuInfo.downSkuIds)
        },
        // 可购买的skulist： 所有sku减去下架和无库存的sku
        storeSkuSpecList() {
          return this.skuSpecList.filter(item => {
            return !this.noStoreSku.includes(item.skuId)
          })
        },
        // 通过sku算法，算出每一个规格项的可选状态,用于筛选规格项是否可选
        availableSpecItems() {
          // 该参数是选中的参数值id，以固定顺序数组传入，如果未选中，则传入''
          const param = this.specMain.map(specId => this.checkedSpecItem[specId]?.id || '')

          return this.chooseSpec(param, this.skuSpecList)
        },
        // 通过sku算法，算出每一个有库存规格项的可选状态，用于筛选规格项是否是缺货下架状态
        storeSpecItems() {
          // 该参数是选中的参数值id，以固定顺序数组传入，如果未选中，则传入''
          const param = this.specMain.map(specId => this.checkedSpecItem[specId]?.id || '')

          return this.chooseSpec(param, this.storeSkuSpecList)
        }
      },
      watch: {
        skuId(skuId) {
          // 如果skuId不等于oldSkuId，重新初始化选中项
          if (this.oldSkuId != skuId) {
            this.oldSkuId = skuId
            this.initCheckedSpecs()
          }
        },
        actIgnore(isIgnore) {
          // 通知其他组件可选项发生变化
          skuEventBus.$emit('avaiSpecChange', this.availableSpecItems, this.storeSpecItems)
        },
        // 检测规格项的变化，如果规格项变化后可以组成新的sku，则向上通报
        checkedSpecItem: {
          handler(val) {
            let specData = {
              oldSkuId: this.skuId,
              skuId: this.skuId,
              isSku: false,
              name: this.skuSpecName
            }

            if (this.isSku()) {
              const specItemIds = this.specMain.map(specId => this.checkedSpecItem[specId].id).join('-')
              const specItemText = this.specMain
                .map(specId => this.checkedSpecItem[specId].name?.replace(/@/g, ' '))
                .join(' ')

              this.skuSpecName = specItemText
              specData.skuId = this.skuMap[specItemIds]
              specData.name = specItemText
              specData.isSku = true
              // 通知订阅组件sku发生了变化
              skuEventBus.$emit('skuChange', {
                skuId: specData.skuId,
                oldSkuId: this.oldSkuId,
                name: this.skuSpecName
              })
              // 更新oldSkuId
              this.oldSkuId = specData.skuId
            }
            // 通知订阅组件选中规格项发生了变化
            skuEventBus.$emit('specChange', specData)
          },
          deep: true
        }
      },
      created() {
        // 注册通信事件
        this.bindEvent()
        // 初始化选中项
        this.initCheckedSpecs()
      },
      methods: {
        /**
         * 注册通信事件，以供版本外显等模块直接驱动sku选择逻辑
         */
        bindEvent() {
          // 当外部选中规格时直接使用sku选择逻辑中的规格选中逻辑
          skuEventBus.$on('selectSpecItem', ({ specId, specItemId, specName, specItemName }) => {
            this.selectSpecItem(specId, specItemId, specName, specItemName)
          })
        },
        /**
         * 初始化checkedSpecItem
         */
        initCheckedSpecs() {
          // 根据skuId找到对应的sku项
          const currentSku = this.skuSpecList.find(item => item.skuId == this.skuId)
          let skuSpecs = {}

          if (currentSku) {
            skuSpecs = currentSku.sequences
          }

          this.specMain.forEach(specId => {
            // 当前sku不存在的话，则选中项初始化为空值
            const specItemId = skuSpecs[specId] || ''
            const specName = this.specMainSeq[specId]
            let specItemName = ''
            if (specItemId) {
              specItemName = this.specItemSeq[specId][specItemId - 1].name
            }
            this.$set(this.checkedSpecItem, specId, {
              id: specItemId,
              name: specItemName
            })
            setTimeout(() => {
              // 通知其他组件可选项发生变化
              skuEventBus.$emit('avaiSpecChange', this.availableSpecItems, this.storeSpecItems)
              // 通知订阅的组件选中的规格项发生了变化
              skuEventBus.$emit('checkedSpecChange', {
                specId,
                specItemId,
                specName,
                specItemName
              })
            })
          })
        },
        getInitData(specId) {
          return {
            availableSpecItems: this.availableSpecItems,
            storeSpecItems: this.storeSpecItems,
            checked: specId ? this.checkedSpecItem[specId] : this.checkedSpecItem,
            checkedSpecData: {
              oldSkuId: this.oldSkuId,
              skuId: this.skuId,
              isSku: this.isSku(),
              name: this.skuSpecName
            }
          }
        },
        /**
         * 通过传入每个规格的选中值，得出其他规格项的规格值是否可选情况
         */
        chooseSpec(checkedSpecItemIds, skuList) {
          return getAvaiSpecs(checkedSpecItemIds, skuList, this.specMain, this.specItemSeq, this.specMainSeq)
        },
        /**
         * 选中某个规格项
         */
        selectSpecItem(specId, specItemId, specName, specItemName) {
          if (this.isDisabled(specId, specItemId)) {
            return
          }

          // 如果是第一规格项，且不能组成SKU，需要清除已选择的规格项，并选中默认规格项
          const specIndex = this.specMain.indexOf(specId)
          if (this.isFirstSpec(specId) && this.availableSpecItems[specIndex].indexOf(specItemId + '') < 0) {
            // 选中具有该规格值的第一个sku,优先取上架有货的sku
            const skuItem =
              this.storeSkuSpecList?.find(item => item.sequences[specId] === specItemId + '') ||
              this.skuSpecList?.find(item => item.sequences[specId] === specItemId + '')
            // 选中该sku的选项
            this.specMain.forEach(specId => {
              const specName = this.specMainSeq[specId]
              const actualSpecItemId = skuItem.sequences[specId]
              const actualSpecItemName = this.specItemSeq[specId][actualSpecItemId - 1].name
              this.checkedSpecItem[specId] = {
                id: actualSpecItemId,
                name: actualSpecItemName
              }
              // 通知其他组件可选项发生变化
              skuEventBus.$emit('avaiSpecChange', this.availableSpecItems, this.storeSpecItems)
              // 通知订阅的组件选中的规格项发生了变化
              skuEventBus.$emit('checkedSpecChange', {
                specId,
                specItemId: actualSpecItemId,
                specName,
                specItemName: actualSpecItemName
              })
            })
          } else {
            // 记录选中的规格项
            this.checkedSpecItem[specId] = {
              id: specItemId,
              name: this.specItemSeq[specId][specItemId - 1].name
            }
            // 通知其他组件可选项发生变化
            skuEventBus.$emit('avaiSpecChange', this.availableSpecItems, this.storeSpecItems)
            // 通知订阅的组件选中的规格项发生了变化
            skuEventBus.$emit('checkedSpecChange', {
              specId,
              specItemId,
              specName,
              specItemName
            })
          }
        },
        // 该规格是否不可选,该状态不能加载第一规格项上
        isDisabled(specId, specItemId) {
          const index = this.specMain.indexOf(specId)
          return !this.isFirstSpec(specId) && this.availableSpecItems[index].indexOf(specItemId + '') < 0
        },

        // 该规格项是否是下架或无货,该状态不能加载第一规格项上
        isDashed(specId, specItemId) {
          const index = this.specMain.indexOf(specId)
          // 该规格项不是第一规格项，且该规格项是可选规格项，且规格项不为有库存规格项 才加下架缺货状态
          return (
            !this.isFirstSpec(specId) &&
            this.availableSpecItems[index].indexOf(specItemId + '') >= 0 &&
            this.storeSpecItems[index].indexOf(specItemId + '') < 0
          )
        },

        // 根据已选的规格项判断是否能组成完整的sku
        isSku() {
          return this.specMain.every(specId => !!(this.checkedSpecItem[specId] && this.checkedSpecItem[specId].id))
        },

        // 判断某个规格项是否是第一规格项，缺货和不可选状态不能加到第一规格项上
        isFirstSpec(specId) {
          // 规格项有多个，且该规格项为第一个，则为第一规格项
          if (this.specMain.length > 1 && this.specMain[0] == specId) {
            return true
          }
          return false
        }
      }
    })
  }
}

export { init, vm }
